export default {
    getMinigameScore(state) {
        return state.minigameScore;
    }
};